<template>
	<div>
		<div>
			<a href="javascript:history.back()" class="btn btn-outline-secondary mr-2 mb-2" v-if="showBackLink">
				<font-awesome-icon icon="arrow-left"/>
				Vissza
			</a>
		</div>

		<div class="text-center">
			<p>The MIT License</p>
			<p>Copyright JS Foundation and other contributors &lt;https://js.foundation/&gt;</p>
			<p>Based on Underscore.js, copyright Jeremy Ashkenas,<br />DocumentCloud and Investigative Reporters &amp; Editors &lt;http://underscorejs.org/&gt;</p>
			<p>This software consists of voluntary contributions made by many<br />individuals. For exact contribution history, see the revision history<br />available at https://github.com/lodash/lodash</p>
			<p>The following license applies to all parts of this software except as<br />documented below:</p>
			<p>====</p>
			<p>Permission is hereby granted, free of charge, to any person obtaining<br />a copy of this software and associated documentation files (the<br />"Software"), to deal in the Software without restriction, including<br />without limitation the rights to use, copy, modify, merge, publish,<br />distribute, sublicense, and/or sell copies of the Software, and to<br />permit persons to whom the Software is furnished to do so, subject to<br />the following conditions:</p>
			<p>The above copyright notice and this permission notice shall be<br />included in all copies or substantial portions of the Software.</p>
			<p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,<br />EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF<br />MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND<br />NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE<br />LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION<br />OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION<br />WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>
			<p>====</p>
			<p>Copyright and related rights for sample code are waived via CC0. Sample<br />code is defined as all source code displayed within the prose of the<br />documentation.</p>
			<p>CC0: http://creativecommons.org/publicdomain/zero/1.0/</p>
			<p>====</p>
			<p>Files located in the node_modules and vendor directories are externally<br />maintained libraries used by this software which have their own<br />licenses; we recommend you read them, as their terms may differ from the<br />terms above.</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "LoadashLicenseView",
	data() {
		return {
			showBackLink: history.length > 1
		}
	}
}
</script>

